const BASE = `/front`;
const API = `/api`;
export const url = {
  api: {
    barcodeScanTerms: {
      pdf: `${BASE}${API}/pdf-viewer/barcode-scan-terms-data`
    },
    changePassword: `${BASE}${API}/change-password`,
    changePasswordSetToken: `${BASE}${API}/change-password/set-token`,
    changePasswordGetToken: `${BASE}${API}/change-password/token`,
    doOrder: `${BASE}${API}/do-order`,
    doReturn: `${BASE}${API}/do-return`,
    enifClubDocument: {
      pdf: `${BASE}${API}/pdf-viewer/enif-club-document-data`
    },
    enifClubTerms: {
      pdf: `${BASE}${API}/pdf-viewer/enif-club-terms-data`
    },
    orderSearch: `${BASE}${API}/order-search/list`,
    orderFavorite: {
      add: `${BASE}${API}/order-favorite/add`,
      delete: `${BASE}${API}/order-favorite/delete`,
      list: `${BASE}${API}/order-favorite/list`,
      update: `${BASE}${API}/order-favorite/update`,
    },
    orderFavoriteItem: {
      add: `${BASE}${API}/order-favorite-item/add`,
      delete: `${BASE}${API}/order-favorite-item/delete`,
      list: `${BASE}${API}/order-favorite-item/list`
    },
    orderToFavorite: `${BASE}${API}/order-to-favorite`,
    orderHistory: {
      list: `${BASE}${API}/order-history/list`
    },
    orderCart: {
      add: `${BASE}${API}/order-cart/add`,
      count: `${BASE}${API}/order-cart/count`,
      delete: `${BASE}${API}/order-cart/delete`,
      list: `${BASE}${API}/order-cart/list`,
      update: `${BASE}${API}/order-cart/update`,
    },
    orderHistoryPdf: `${BASE}${API}/order-history/pdf`,
    returnSearch: `${BASE}${API}/return-search/list`,
    returnScanSearch: `${BASE}${API}/return-scan-search/list`,
    returnHistory: {
      list: `${BASE}${API}/return-history/list`
    },
    returnBox: {
      add: `${BASE}${API}/return-box/add`,
      count: `${BASE}${API}/return-box/count`,
      delete: `${BASE}${API}/return-box/delete`,
      list: `${BASE}${API}/return-box/list`,
      update: `${BASE}${API}/return-box/update`,
    },
    serviceApply: {
      get: `${BASE}${API}/service-apply/get`,
      applyEnifClub: `${BASE}${API}/service-apply/apply-enif-club`,
      applyBarcodeScan: `${BASE}${API}/service-apply/apply-barcode-scan`,
    },
    messages: `${BASE}${API}/messages`,
    orderTerms: {
      agree: `${BASE}${API}/order-terms/agree`,
      pdf: `${BASE}${API}/pdf-viewer/order-terms-data`
    },
    returnTerms: {
      agree: `${BASE}${API}/return-terms/agree`,
      pdf: `${BASE}${API}/pdf-viewer/return-terms-data`
    },
    orderList: `${BASE}${API}/order/list`,
    goodsTypes: `${BASE}${API}/goods-type`,
    deliveryStatuses: `${BASE}${API}/delivery-status`,
    orderDataUpdateDate: `${BASE}${API}/order-data/update-time`,
    updateComment: `${BASE}${API}/comment/update`,
    identicalFormulationList: `${BASE}${API}/identical-formulation/list`,
    identicalFormulationOrder: `${BASE}${API}/identical-formulation/order`,
    userData: `${BASE}${API}/user-data`,
    advertisement: `${BASE}${API}/ad/list`,
    news: {
      list: `${BASE}${API}/news/list`,
      detail: `${BASE}${API}/news/newsId`
    },
    supportLink: `${BASE}${API}/support-link/list`,
    verificationCode: {
      verify: `${BASE}${API}/verification-code/verify`,
      resend: `${BASE}${API}/verification-code/resend`,
    },
    email: `${BASE}${API}/email/update`,
    emailSetting: `${BASE}${API}/email-setting/update`,
    password: `${BASE}${API}/password/update`,
    actionHistory: `${BASE}${API}/action/history`,
    passwordResetMail: `${BASE}${API}/password-reset-mail/request`,
    passwordReset: `${BASE}${API}/password-reset`,
    layoutSetting: `${BASE}${API}/layout-setting/update`,
    qrDecoderNeo: {
      license: `${BASE}${API}/qrDecoderNeo/license`,
    },
    mobileDevices: {
      add: `${BASE}${API}/mobile-devices/add`,
      delete: `${BASE}${API}/mobile-devices/delete`,
      list: `${BASE}${API}/mobile-devices/list`,
      update: `${BASE}${API}/mobile-devices/update`,
    }
  },
  page: {
    top: '/',
    setting: {
      index: '/setting',
      password: '/setting/password/change'
    },
    news: {
      list: '/news',
      detail: '/news/:id'
    },
    orderSearch: '/order-search',
    orderHistory: '/order-history',
    orderFavorite: '/order-favorite',
    orderFavoriteDetail: '/order-favorite-detail',
    orderCart: '/order-cart',
    returnSearch: '/return-search',
    returnHistory: '/return-history',
    returnBox: '/return-box',
    orderResults: '/order-results',
    passwordReset: {
      forgotPassword: '/forgot-password',
      forgotPasswordComplete: '/forgot-password/complete',
      resetPasswordComplete: '/password/reset'
    },
    orderScan: '/order-scan',
    returnScan: '/return-scan',
    other: {
      about: '/static/contents/manual.pdf',
      questions: 'https://kyosomirai-portal.com/static/contents/questions.html',
      terms: '/static/contents/terms.pdf',
      environment: '/static/contents/environment.pdf',
      company: 'https://www.tohohd.co.jp',
    }
  },
  login: `${BASE}/login`,
  logout: `${BASE}/logout`,
  error: `${BASE}/error`,
  static: {
    fileIcon: `${BASE}/assets/common/img/icon_pdf1.png`,
    loadingIcon: `${BASE}/assets/common/img/loading.gif`,
    scanSound1: `${BASE}/assets/common/sound/scan_sound1.mp3`,
    scanSound2: `${BASE}/assets/common/sound/scan_sound2.mp3`,
  },
  external: {
    pmda: 'https://www.pmda.go.jp/PmdaSearch/bookSearch/01/{GTIN}',
    enif: 'https://i-enif.tohoyk.co.jp/izai/{DOCNUM}.pdf'
  },
}

// defaultエクスポートも追加
export default url